import React from 'react';
// import style from './UOMSlider.scss';
import ListItem from 'jd-library/ListItem';
import Button from 'jd-library/Button';
import Image, { AddVideoDiv } from '../../common/product-image/ImageViewUpload';


const SingleProductList = props =>{
    return(
        <>
            <div className={'single-conflict-holder'}>
                <ListItem
                    className={'normal-menu'}
                    leftSection={
                        <div className={"single-conflict-image"}>
                            <Image
                                imageUrl={props.prodData.productPhotoUrl}
                                isReadOnly={true}
                            />
                        </div>
                    }
                    middleSection={
                        <div className="mid-section">
                            <div className="single-prod-title">
                                {props.prodData.productName}
                            </div>
                            <div className="single-prod-unit mgb-5">
                            { props.type == 'retain' ?
                                <p className={""}>
                                    Barcode: {props.prodData.barcode}
                                </p>
                                :
                                ( props.prodData.contentPerPiece && props.prodData.contentPerPiece > 1 ? (
                                    <p className={""}>
                                        {Number(props.prodData.contentPerPiece) + ' ' + props.getUom(props.prodData.unitPerPiece)}
                                    </p>
                                ):'')
                            }    
                            </div>
                            <div className="select-prod-btn">
                                <Button
                                    children={props.btnLebal}
                                    variant='default'
                                    className=""
                                    onClick={()=> props.handleProductClick(props.prodData,props.type)}
                                />  
                            </div>
                        </div>

                    }
                />
            </div>
			{props.type =='suggested' && <div className="card-divider"></div>}
        </>
	)
}

export default SingleProductList;